module.exports = __webpack_public_path__ + "img/24.95fd8ae2.png";